import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"
import { default as BuoyLoadingScreen } from "buoy-loading-screen"

const LoadingScreenWrapper = styled.div`
  background: #fff;
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
`

const LoadingScreenContainer = ({ showLoadingScreen }) =>
  showLoadingScreen ? (
    <LoadingScreenWrapper>
      <BuoyLoadingScreen />
    </LoadingScreenWrapper>
  ) : null

const mapStateToProps = state => ({
  showLoadingScreen: state.showLoadingScreen,
})

const LoadingScreenConnected = connect(mapStateToProps)(LoadingScreenContainer)
export { LoadingScreenConnected as default }



// WEBPACK FOOTER //
// ./assets/common/components/LoadingScreen.js